import React from 'react'

export default function LeftArrowIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 7L9.5 12L14.5 17" stroke="currentColor"/>
</svg>

  )
}
